<ridango-block-full-width *ngFor="let product of products">
    <div class="ticket-selection__ticket-container">
        <div class="ticket-selection__col-product-title">
            <div class="ticket-selection__col-title padding-top-bottom-20">
                {{ product | translateObjectField: 'name' : translate.currentLang }}
            </div>
        </div>
        <div class="ticket-selection__col-price">
            <span class="ticket-selection__price">
                {{ product.price | moneyFormat }} {{ appStartupService.getCurrency() | translate }}
            </span>
        </div>

        <div class="ticket-selection__col-select-amount">
            <div class="ticket-selection__col-add">
                <button
                    class="btn btn--col-add btn--square-small dark:text-black"
                    [disabled]="productAddingIsDisabled()"
                    [class.dark:text-black]="!productAddingIsDisabled()"
                    (click)="addTicket(product.product_id)">
                    +
                </button>
            </div>

            <div class="ticket-selection__col-count">
                {{ getProductSelectedAmount(product.product_id) }}
            </div>

            <div class="ticket-selection__col-remove">
                <button
                    class="btn btn--col-remove btn--square-small"
                    [disabled]="productRemovingIsDisabled(product.product_id)"
                    (click)="removeTicket(product.product_id)">
                    -
                </button>
            </div>
        </div>
    </div>
</ridango-block-full-width>
